'use client';

import { useTranslation } from '@/context/LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

export default function ProdiListSection() {
  const { t } = useTranslation();

  // This would ideally come from an API based on the Faculty ID
  const programs = [
    { name: 'Program Studi 1', degree: 'S1' },
    { name: 'Program Studi 2', degree: 'S1' },
    { name: 'Program Studi 3', degree: 'S2' },
    { name: 'Program Studi 4', degree: 'S3' },
  ];

  return (
    <section id="prodi-list" className="py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-unmulDarkGreen">
            PROGRAM <span className="text-unmulYellow">STUDI</span>
          </h2>
          <p className="text-gray-600 mt-4 max-w-3xl mx-auto text-lg">
            Pilihan program studi yang tersedia di fakultas kami.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {programs.map((program, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition flex justify-between items-center group">
              <div>
                <span className="inline-block px-3 py-1 bg-unmulPale text-unmulGreen text-xs font-bold rounded-full mb-2">
                  {program.degree}
                </span>
                <h3 className="text-lg font-bold text-gray-800 group-hover:text-unmulGreen transition">{program.name}</h3>
              </div>
              <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center text-gray-400 group-hover:bg-unmulGreen group-hover:text-white transition">
                <FontAwesomeIcon icon={faChevronRight} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
